// extracted by mini-css-extract-plugin
export var avatarContainer = "_87-0";
export var avatarTypingWave = "_87-i";
export var gray = "_87-f";
export var green = "_87-c";
export var icon = "_87-9";
export var image = "_87-1";
export var lg = "_87-6";
export var md = "_87-5";
export var presenceDot = "_87-b";
export var red = "_87-d";
export var sm = "_87-4";
export var status = "_87-a";
export var typingDot = "_87-h";
export var typingPill = "_87-g";
export var xl = "_87-7";
export var xs = "_87-3";
export var xxl = "_87-8";
export var xxs = "_87-2";
export var yellow = "_87-e";